const initialState = {
	isLoading: false,
	selected: false,
	forumById: {},
	forumLoadingById: {},
	selectedTopic: false,
	newRepliesAvailable: false,
	topicById: {},
	topicLoadingById: {},
}

export default function pageReducer( state = initialState, action ) {
	const { type, payload } = action
	let isLoading,
		selected,
		selectedTopic,
		newTopicById,
		newTopic

	switch ( type ) {
		case 'REQUEST_FORUM_DATA':
			isLoading = payload.requentOnly ? state.isLoading : true

			return {
				...state,
				isLoading: isLoading,
				error: false,
				forumLoadingById: {
					...state.forumLoadingById,
					[ payload.slug ]: true
				}
			}

		case 'RECEIVE_FORUM_DATA':
			let newForumById = {
				...state.forumById
			}

			if ( newForumById[ 'id_' + payload.slug ] ) {
				newForumById[ 'id_' + payload.slug ] = payload.data
			} else {
				newForumById = {
					[ 'id_' + payload.slug ]: payload.data,
					...state.forumById
				}
			}

			return {
				...state,
				isLoading: false,
				error: false,
				forumById: newForumById,
				forumLoadingById: {
					...state.forumLoadingById,
					[ 'id_' + payload.slug ]: false
				}
			}

		case 'SET_CURRENT_FORUM':
			selected = state.selected

			if ( state.forumById[ 'id_' + payload ] ) {
				selected = state.forumById[ 'id_' + payload ]
			}

			return {
				...state,
				selected: selected
			}

		case 'REQUEST_FORUM_TOPIC_DATA':
			isLoading = payload.requestOnly ? state.isLoading : true

			return {
				...state,
				isLoading: isLoading,
				error: false,
				topicLoadingById: {
					...state.topicLoadingById,
					[ payload.slug ]: true
				}
			}

		case 'RECEIVE_FORUM_TOPIC_DATA':
			newTopicById = {
				...state.topicById
			}
			selectedTopic = state.selectedTopic
			let newRepliesAvailable = state.newRepliesAvailable

			if ( newTopicById[ 'id_' + payload.slug ] ) {
				newTopicById[ 'id_' + payload.slug ] = payload.data
			} else {
				newTopicById = {
					[ 'id_' + payload.slug ]: payload.data,
					...state.topicById
				}
			}

			// Update the selected topic if needed:
			if ( state.selectedTopic ) {
				let selectedTopicRepliesN = Object.keys( selectedTopic.replies ).length
				let newSelectedTopicRepliesN = Object.keys( payload.data.replies ).length

				if ( selectedTopic.id == payload.data.id ) {
					selectedTopic = payload.data
				}

				if ( selectedTopicRepliesN != newSelectedTopicRepliesN ) {
					newRepliesAvailable = true
				}
			}

			return {
				...state,
				isLoading: false,
				error: false,
				topicById: newTopicById,
				topicLoadingById: {
					...state.topicLoadingById,
					[ 'id_' + payload.slug ]: false
				},
				selectedTopic: selectedTopic,
				newRepliesAvailable: newRepliesAvailable
			}

		case 'SET_CURRENT_FORUM_TOPIC':
			selectedTopic = state.selectedTopic

			if ( state.topicById[ 'id_' + payload ] ) {
				selectedTopic = state.topicById[ 'id_' + payload ]
			}

			return {
				...state,
				selectedTopic: selectedTopic
			}

		case 'SET_NEW_REPLIES_NOTICE_AS_SEEN':
			return {
				...state,
				newRepliesAvailable: false
			}

		case 'ADD_FORUM_REPLY':
			newTopic = {
				...state.topicById[ 'id_' + state.selectedTopic.slug ],
				replies: {
					...state.topicById[ 'id_' + state.selectedTopic.slug ].replies,
					[ 'id_' + payload.id ]: {
						id: payload.id,
						content: {
							rendered: payload.content
						},
						date: {
							iso: payload.dateIso
						},
						author: {
							name: payload.authorName
						}
					}
				}
			}

			newTopicById = {
				...state.topicById,
				[ 'id_' + state.selectedTopic.slug ]: newTopic
			}

			return {
				...state,
				isLoading: false,
				error: false,
				selectedTopic: newTopic,
				topicById: newTopicById,
				topicLoadingById: {
					...state.topicLoadingById,
					[ 'id_' + state.selectedTopic.slug ]: false
				}
			}

		case 'ADD_FORUM_REPLY_LIKE':
			let likes = parseInt( state.topicById[ 'id_' + state.selectedTopic.slug ].replies[ 'id_' + payload.id ].likes )

			if ( ! likes ) {
				likes = 0
			}

			let newLikes = payload.liked ? likes + 1 : likes - 1

			if ( newLikes < 0 ) {
				newLikes = 0
			}

			newTopic = {
				...state.topicById[ 'id_' + state.selectedTopic.slug ],
				replies: {
					...state.topicById[ 'id_' + state.selectedTopic.slug ].replies,
					[ 'id_' + payload.id ]: {
						...state.topicById[ 'id_' + state.selectedTopic.slug ].replies[ 'id_' + payload.id ],
						likes: newLikes,
						has_liked: payload.liked
					}
				}
			}

			newTopicById = {
				...state.topicById,
				[ 'id_' + state.selectedTopic.slug ]: newTopic
			}

			return {
				...state,
				isLoading: false,
				error: false,
				selectedTopic: newTopic,
				topicById: newTopicById
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/forum.jsx